import React, { useEffect, useState } from 'react';
import { catalogApi } from '../lib/api';
import { REQUEST_STATUS_LABEL, TRANSACTION_STATUS_LABEL, t } from '../lib/catalogI18n';

export default function MyAccesses() {
  const [reqs, setReqs] = useState([]);
  const [txs, setTxs] = useState([]);
  useEffect(() => {
    catalogApi.myRequests().then(r => setReqs(r.data)).catch(() => {});
    catalogApi.myTransactions().then(r => setTxs(r.data)).catch(() => {});
  }, []);
  return (
    <div className="p-6 space-y-6" data-testid="my-accesses-page">
      <h1 className="text-3xl font-bold">Mis solicitudes y transacciones</h1>

      <section>
        <h2 className="text-lg font-semibold mb-2">Solicitudes</h2>
        {reqs.length === 0 ? <p className="text-gray-500">Sin solicitudes.</p> : (
          <div className="bg-white rounded-lg border overflow-hidden">
            <table className="w-full text-sm">
              <thead className="bg-gray-50 text-gray-600">
                <tr>
                  <th className="px-3 py-2 text-left">Código</th>
                  <th className="px-3 py-2 text-left">Estado</th>
                  <th className="px-3 py-2 text-left">Fecha</th>
                  <th className="px-3 py-2 text-left">Versión condiciones</th>
                </tr>
              </thead>
              <tbody>
                {reqs.map(r => (
                  <tr key={r.id} className="border-t" data-testid={`req-row-${r.request_code}`}>
                    <td className="px-3 py-2 font-mono">{r.request_code}</td>
                    <td className="px-3 py-2">{t(REQUEST_STATUS_LABEL, r.status)}</td>
                    <td className="px-3 py-2">{new Date(r.created_at).toLocaleString()}</td>
                    <td className="px-3 py-2">{r.terms_version}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </section>

      <section>
        <h2 className="text-lg font-semibold mb-2">Transacciones</h2>
        {txs.length === 0 ? <p className="text-gray-500">Sin transacciones.</p> : (
          <div className="bg-white rounded-lg border overflow-hidden">
            <table className="w-full text-sm">
              <thead className="bg-gray-50 text-gray-600">
                <tr>
                  <th className="px-3 py-2 text-left">Código</th>
                  <th className="px-3 py-2 text-left">Producto</th>
                  <th className="px-3 py-2 text-left">Indicador</th>
                  <th className="px-3 py-2 text-left">n</th>
                  <th className="px-3 py-2 text-left">Estado</th>
                  <th className="px-3 py-2 text-left">Fecha</th>
                </tr>
              </thead>
              <tbody>
                {txs.map(tx => (
                  <tr key={tx.id} className="border-t" data-testid={`tx-row-${tx.transaction_code}`}>
                    <td className="px-3 py-2 font-mono">{tx.transaction_code}</td>
                    <td className="px-3 py-2 font-mono text-xs">{tx.product_id.slice(0, 8)}…</td>
                    <td className="px-3 py-2">{tx.indicator_code}</td>
                    <td className="px-3 py-2">{tx.aggregation_count}</td>
                    <td className="px-3 py-2">{t(TRANSACTION_STATUS_LABEL, tx.status)}</td>
                    <td className="px-3 py-2">{new Date(tx.created_at).toLocaleString()}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </section>
    </div>
  );
}
